import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';

export const scrollableContainerDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
    childExists: dataHook => base.$(`[data-hook="${dataHook}"]`).exists(),
  };
};
